import React, { useEffect } from "react"
import useSessionContext from "../../hooks/contextConsumers/useSessionContext.hook"
import { useNavigate } from "react-router-dom"
import {
  BASE_ROUTE_PER_ROLE,
  Role as TEAM_MEMBER_ROLES,
} from "../../consts/roles.consts"
import { AppRoutes } from "../../consts/appRoutes.consts"

export default function Home() {
  const { user } = useSessionContext()
  const navigate = useNavigate()
  const allowedRoutes = [AppRoutes.home.index, AppRoutes.auth.loginExplicit]
  useEffect(() => {
    if (!allowedRoutes.includes(location.pathname)) return
    if (user.rol === TEAM_MEMBER_ROLES.ADMIN) {
      navigate(BASE_ROUTE_PER_ROLE.admin)
    } else {
      navigate(BASE_ROUTE_PER_ROLE.teamMember)
    }
  }, [])
  return <span>👀</span>
}
